import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetHealth from './CharacterSheetHealth.vue';
import CharacterSheetExperience from './CharacterSheetExperience.vue';
import CharacterSheetConditions from './CharacterSheetConditions.vue';
import CharacterMenu from '../CharacterMenu.vue';
import CharacterSheetMenuButton from './CharacterSheetMenuButton.vue';
import MyDialog from '@/components/MyDialog.vue';
import { namespace } from 'vuex-class';
import { isEmpty, merge } from 'lodash';
const authenticationModule = namespace('authentication');
let CharacterSheetTop = class CharacterSheetTop extends Vue {
    constructor() {
        super(...arguments);
        this.isMenuOpen = false;
        this.clearedTweaks = {};
        this.isEmpty = isEmpty;
    }
    clearAllTweaks() {
        this.clearedTweaks = this.rawCharacter.tweaks;
        this.$emit('replaceCharacterProperty', { path: 'tweaks', property: {} });
        window.alert('All tweaks cleared!');
    }
    undoClearTweaks() {
        this.$emit('replaceCharacterProperty', {
            path: 'tweaks',
            property: merge({}, this.rawCharacter.tweaks, this.clearedTweaks)
        });
        this.clearedTweaks = {};
        window.alert('Tweaks restored!');
    }
};
__decorate([
    Prop(Object)
], CharacterSheetTop.prototype, "completeCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterSheetTop.prototype, "rawCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterSheetTop.prototype, "characterValidation", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetTop.prototype, "isDirty", void 0);
__decorate([
    authenticationModule.Getter
], CharacterSheetTop.prototype, "isLoggedIn", void 0);
CharacterSheetTop = __decorate([
    Component({
        components: {
            CharacterSheetHealth,
            CharacterSheetExperience,
            CharacterSheetConditions,
            CharacterMenu,
            CharacterSheetMenuButton,
            MyDialog
        }
    })
], CharacterSheetTop);
export default CharacterSheetTop;
